import {
  BTC_REGEX,
  ETH_REGEX,
  MAX_XRP_TAG_VALUE,
  TRX_REGEX,
  XRP_REGEX,
} from "features/payouts/PayoutMethods/constants.ts";
import { CryptoAsset, CryptoNetwork } from "@shared/types";

export const isValidXrpTag = (tag?: number) => {
  if (tag === undefined) return true;

  const n = Number(tag);
  return Number.isInteger(n) && n >= 0 && n <= MAX_XRP_TAG_VALUE;
};

export const validateAddress = (
  address: string,
  asset?: CryptoAsset,
  network?: CryptoNetwork
) => {
  if (!address) return false;

  if (asset === CryptoAsset.BTC) {
    return BTC_REGEX.test(address);
  } else if (asset === CryptoAsset.USDT) {
    if (network === CryptoNetwork.ETH) return ETH_REGEX.test(address);
    if (network === CryptoNetwork.TRX) return TRX_REGEX.test(address);
    return false;
  } else if (asset === CryptoAsset.XRP) {
    return XRP_REGEX.test(address);
  }
  return false;
};
